import '../../../node_modules/cookie/index.esm.js';
import { LOCATION_LITE_KEY } from '@invitae/location-lite-core';
import { __exports as cookie } from '../../../_virtual/index.esm.js';

/**
 * Returns the `onCookieChange` handler that is called when document cookies change
 *
 * Abstracted for testing purposes
 * @param setCookieContent access to set document cookies, passed in by parent hook
 */
var getOnCookieChange = function (setCookieContent) {
    /**
     * Change handler, called when _any_ document cookie changes
     *
     * This handler identifies if specifically the `locationLite` cookie value has changed
     * If the change is to a cookie value _other than_ `locationLite`, this is a no-op
     */
    return function onCookieChange(_a, repeater) {
        var newValue = _a.newValue, oldValue = _a.oldValue;
        /**
         * Compare old and new locationLite cookie values
         * These are the string values of the encoded object cookie - `cookie.parse` does _not_ parse individual cookie _values_
         * Note that cookie.parse will always return an object, even if nothing is parsed
         * No need to decode or re-encode for this step, as string comparison is simpler
         */
        var oldLocationCookieStringValue = cookie.parse(oldValue)[LOCATION_LITE_KEY];
        var newLocationCookieStringValue = cookie.parse(newValue)[LOCATION_LITE_KEY];
        if (oldLocationCookieStringValue !== newLocationCookieStringValue) {
            /**
             * Directly re-set the cookie via react-cookie, so react components become aware of the update
             * works around https://github.com/reactivestack/cookies/issues/304
             *
             * No need to adjust or augment the cookie object, as it has been fully populated by the server
             */
            setCookieContent(newLocationCookieStringValue);
            /**
             * Stop polling once we detect a change - this indicates that the cookie has been set initially by the server
             *
             * From here, since we no longer care about cookies set by XHR, we can rely totally on `react-cookie`
             */
            if (repeater !== undefined) {
                clearInterval(repeater);
            }
        }
    };
};

export { getOnCookieChange };
//# sourceMappingURL=onCookieChange.esm.js.map
